var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNoBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 4.875C2.78921 4.875 3.125 5.21079 3.125 5.625V15C3.125 15.8284 3.79657 16.5 4.625 16.5H11.375C12.2034 16.5 12.875 15.8284 12.875 15V5.625C12.875 5.21079 13.2108 4.875 13.625 4.875C14.0392 4.875 14.375 5.21079 14.375 5.625V15C14.375 16.6569 13.0319 18 11.375 18H4.625C2.96815 18 1.625 16.6569 1.625 15V5.625C1.625 5.21079 1.96079 4.875 2.375 4.875Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 0C5.29657 0 4.625 0.671573 4.625 1.5V2.25L0.875 2.25C0.460787 2.25 0.125 2.58579 0.125 3C0.125 3.41422 0.460787 3.75 0.875 3.75L15.125 3.75C15.5392 3.75 15.875 3.41422 15.875 3C15.875 2.58579 15.5392 2.25 15.125 2.25L11.375 2.25V1.5C11.375 0.671573 10.7034 0 9.875 0H6.125ZM9.875 2.25V1.5H6.125V2.25L9.875 2.25Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 14.25C5.71079 14.25 5.375 13.9142 5.375 13.5V7.5C5.375 7.08579 5.71079 6.75 6.125 6.75C6.53921 6.75 6.875 7.08579 6.875 7.5V13.5C6.875 13.9142 6.53921 14.25 6.125 14.25Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 14.25C9.46079 14.25 9.125 13.9142 9.125 13.5V7.5C9.125 7.08579 9.46079 6.75 9.875 6.75C10.2892 6.75 10.625 7.08579 10.625 7.5V13.5C10.625 13.9142 10.2892 14.25 9.875 14.25Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNoBorder);
export default __webpack_public_path__ + "static/media/DeleteNoBorder.9a570f8139c9a0df8ef3afb6a22be24d.svg";
export { ForwardRef as ReactComponent };